module.exports = __webpack_public_path__ + "media/images/img-post-377c864dbf1b08989cc9b7d4ca357824.jpg";